<template>
    <section class="highlight title">
        <ogt-video ref="video" src="/static/video/highlight.mp4" poster="/static/video/highlight-poster.jpg"></ogt-video>
        <h1 class="bigger">Highlights 2020</h1>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_title.scss
</style>

<script>
    import { gsap } from '@/vendor';

    import OgtVideo from '@/app/components/OgtVideo';
    import Beeldweb from '@/app/pages/highlight/Beeldweb';

    export default {
        name: 'Highlights',
        meta: {
            title: '5. Highlights 2020',
            color: '#a5147e',
            slides: [Beeldweb]
        },

        components: {
            'ogt-video': OgtVideo
        },

        mounted()
        {
            this.tl = gsap.timeline({ paused: true });
            this.tl.fromTo( 'section.highlight.title h1', { y: 20, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.5 });
        },
        methods: {
            focus()
            {
                this.tl.play();
                this.$refs.video.play();
            }
        }
    };
</script>
